import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as TipoParticipantes from '../../constantes/TipoParticipantesTorneo.js';
import { NombreEquipoTorneo } from '../../funciones/FuncionesEquipo.js';
import MensajeError from '../../UI/MensajeError.js';
import useGetListaURL from '../../../hooks/useGetListaURL.js';

const UltimosCampeonesOrganizador = (props) => {
  const organizador = props.organizador;
  const styles = props.styles;
  const [listaTorneos, setListaTorneos] = useState([]);
  const { erroresGetLista, fetchData, resetErroresGetLista } = useGetListaURL();

  useEffect(() => {
    resetErroresGetLista();
  }, [resetErroresGetLista]);

  useEffect(() => {
    if (organizador) {
      fetchData(
        'torneos/ultimos_campeones?oficialidad=' +
          organizador.oficialidad +
          '&tipoParticipacion=' +
          TipoParticipantes.SELECCIONES +
          '&limiteAnios=4',
        setListaTorneos
      );
    } else {
      setListaTorneos([]);
    }
  }, [organizador, fetchData]);

  return (
    <React.Fragment>
      {listaTorneos && listaTorneos.length > 0 && (
        <React.Fragment>
          {listaTorneos.map((torneo, index) => (
            <tr key={index} className={`${styles.filaTorneo}`}>
              <td className={`${styles.torneo}`}>
                <Link to={'/torneos/' + torneo.id}>{torneo.descripcion}</Link>
              </td>
              <td className={`${styles.campeon}`}>
                {Array.isArray(torneo.campeones)
                  ? torneo.campeones.map((equipo, index_) => (
                      <div key={index_}>{NombreEquipoTorneo(equipo, torneo)}</div>
                    ))
                  : NombreEquipoTorneo(torneo.campeones, torneo)}
              </td>
              <td className={`${styles.subCampeon}`}>
                {Array.isArray(torneo.subCampeones)
                  ? torneo.subCampeones.map((equipo, index_) => (
                      <div key={index_}>{NombreEquipoTorneo(equipo, torneo)}</div>
                    ))
                  : NombreEquipoTorneo(torneo.subCampeones, torneo)}
              </td>
            </tr>
          ))}
          <MensajeError errores={erroresGetLista} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default UltimosCampeonesOrganizador;
